// extracted by mini-css-extract-plugin
export default {"name":"organizationRow__name-YMdai","menu":"organizationRow__menu-xY_8c"};